import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { FormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { Category } from '../../../../../shared/interfaces/category';
import { SlugifyPipe } from '../../../../../shared/pipes/slugify.pipe';
import { ConsoleLoggerService } from '../../../../../core/services/console-logger.service';
import { FirestoreService } from '../../../../../shared/services/firestore.service';

@Component({
  selector: 'anon-new-category',
  templateUrl: './new-category.component.html',
  styleUrls: ['./new-category.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewCategoryComponent {
  category!: Category;
  addCategoryForm = new FormGroup({
    name: new UntypedFormControl('', Validators.required),
    description: new UntypedFormControl(''),
    slug: new UntypedFormControl('', Validators.required),
    featured: new UntypedFormControl(false),
    image: new UntypedFormControl(''),
  });

  constructor(
    private dialogRef: MatDialogRef<NewCategoryComponent>,
    private db: FirestoreService,
    private slugify: SlugifyPipe,
    private cLog: ConsoleLoggerService
  ) { }
  get name() { return this.addCategoryForm.get('name'); }
  get description() { return this.addCategoryForm.get('description'); }
  get slug() { return this.addCategoryForm.get('slug'); }
  get image() { return this.addCategoryForm.get('image'); }
  get featured() { return this.addCategoryForm.get('featured'); }

  closeDialog() {
    this.dialogRef.close();
  }

  setSlug(event: any) {
    this.slug?.setValue(this.slugify.transform(event.target.value));
  }

  async createCategory() {
    const category = this.addCategoryForm?.value;
    if (await this.db.docExists(`categories/${category.slug}`)) {
      return this.cLog.error(`Category with slug already exists: ${category.slug}`);
    }
    this.db.set(`categories/${category.slug}`, category)
      .then(() => this.closeDialog());
  }

}
